import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { Link } from 'gatsby'

import { MetaData } from '../../components/common/meta'
import Layout from '../../components/Layout'
import RecentPosts from '../../components/RecentPosts'
import CallToAction from '../../components/CallToAction'

function Post({ data, location }) {
  const post = data.ghostPost
  const recentPosts = data.allGhostPost.nodes

  const isKnowledgeBaseArticle = !!post.tags.find(
    ({ slug }) => slug === 'knowledge-base',
  )

  const content = post.html.replaceAll(process.env.GATSBY_GHOST_API_URL, '')

  return (
    <>
      <MetaData data={data} location={location} type="website" />
      <Helmet>
        <style type="text/css">{`${post.codeinjection_styles}`}</style>
      </Helmet>
      <Layout sidebar>
        <div className="container">
          <div className="flex justify-center">
            <div id="left-area" className="max-w-3xl flex-1">
              <article className="et_pb_post post type-post status-publish format-standard hentry">
                <h1 className="main_title">{post.title}</h1>
                {post.feature_image ? (
                  <img src={post.feature_image} alt={post.title} />
                ) : null}
                <div
                  className="prose lg:prose-xl"
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: content,
                  }}
                />
                {isKnowledgeBaseArticle ? (
                  <p id="btkb">
                    <Link to="/knowledge-base" title="Back">
                      Back to the knowledge base
                    </Link>
                  </p>
                ) : null}
                <CallToAction />
              </article>
            </div>
            <div id="sidebar">
              <RecentPosts posts={recentPosts} />
            </div>
          </div>
        </div>
      </Layout>
    </>
  )
}

Post.propTypes = {
  data: PropTypes.shape({
    ghostPost: PropTypes.shape({
      codeinjection_styles: PropTypes.string,
      title: PropTypes.string.isRequired,
      feature_image: PropTypes.string,
      tags: PropTypes.arrayOf(
        PropTypes.shape({
          slug: PropTypes.string.isRequired,
        }),
      ).isRequired,
      html: PropTypes.string.isRequired,
    }).isRequired,
    allGhostPost: PropTypes.shape({
      nodes: PropTypes.arrayOf(
        PropTypes.shape({
          slug: PropTypes.string.isRequired,
          title: PropTypes.string.isRequired,
          published_at: PropTypes.string.isRequired,
          excerpt: PropTypes.string.isRequired,
        }),
      ),
    }),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
}

export default Post
